var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTempSub(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 8V2C20 0.9 19.1 0 18 0H2C0.9 0 0.00999999 0.9 0.00999999 2L0 14C0 15.1 0.9 16 2 16H13V11C13 9.34 14.34 8 16 8H20ZM10 9L2 4V2L10 7L18 2V4L10 9Z",
    fill: "#E66100"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 12V16C20 17.1 19.1 18 18 18C16.9 18 16 17.1 16 16V11.5C16 11.22 16.22 11 16.5 11C16.78 11 17 11.22 17 11.5V16H19V11.5C19 10.12 17.88 9 16.5 9C15.12 9 14 10.12 14 11.5V16C14 18.21 15.79 20 18 20C20.21 20 22 18.21 22 16V12H20Z",
    fill: "#E66100"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTempSub);
export default __webpack_public_path__ + "static/media/temp-sub.884fe425571bf3ab607dd12e3a075dfe.svg";
export { ForwardRef as ReactComponent };